import "./style.scss"
import { useDispatch } from "react-redux"
import { incrementByAmount } from "../../store/Header";
import { useEffect, useState } from "react";
import { getBlogsListAPI } from "../../api";
import { useNavigate } from "react-router-dom";
import BlogCom from "../../components/BlogCom";
import EadlineCom from "../../components/EadlineCom";
import ChatCom from "../../components/ChatCom";
import { teacherList, teacherListHk, course, courseHk } from "./config.js";
const HongKongMathsPage = () => {
    const dispatch = useDispatch()
    const nav = useNavigate();
    const [isShow, setIsShow] = useState(false);
    const [dataList1, setDataList1] = useState(teacherList);
    const [hkTeacher, setHkTeacher] = useState(teacherListHk);
    const [courseData, setCourseData] = useState(course);
    const [blogList, setBlogList] = useState(null)
    const [courseHkList, setCourseHkList] = useState(courseHk);
    useEffect(() => {
        dispatch(incrementByAmount(3))
        getBlogsListAPI({ type: '1', page: 1, limit: 10 }).then((res) => {
            setBlogList(res);
        })
    }, [])
    const goMath = (url) => {
        nav(url);
    };
    const teacherInfoCom = (item, index) => {
        return (
            <div className="teacherItem" key={index}>
                <div className="teacherName">
                    <img className="photo" src={item.picture} alt="" />
                    <div className="name">{item.name}</div>
                </div>
                <div className="teacherInfo">
                    {item.introduce.split('/').map((item, index1) => {
                        return <div className="infoItem" key={index1}>
                            <div>
                                <div className="drop"></div>
                            </div>
                            <div>{item}</div>
                        </div>
                    })} </div></div>
        )
    }
    const classListCom = (item, index) => {
        return (<div className="classItem" key={index}>
            <img className="classIcon" src={item.photo} alt="" />
            <div className="calssTitle">{item.name}</div>
            {item.content}
        </div>)
    }
    const advantagetCom = (item, index) => {
        return <div className="advantageItem" key={index}>
            <img src="../assets/maths/20.png" alt="" className="advantageIcon" />
            <div>{item.content}</div>
        </div>
    }
    const teacherItemCom = (item, index) => {
        return (<div className={["teacher_item", index === 1 || index === 4 ? 'tow' : '', index === 2 || index === 5 ? 'therr' : '',].join(" ")} key={index}>
            <img className="teachet_ph" src={item.picture} alt="" />
            <div>
                <div className="teacher_name">{item.name}</div>
                <div className="teacher_info">{item.introduce.replace(/\//g, '。')}</div></div>
        </div>)
    }
    const subheadingCom = (item, index) => {
        return (<div className={["grade_item", `grade_item${index + 1}`].join(" ")} key={index}>
            <div className="gradeName">{item.name}</div>
            <div className="gradeContent">{item.content}</div>
        </div>)
    };
    const goUrl = () => {
        let url = "https://wa.me/8617788052878?text=%E5%92%A8%E8%AF%A21V1%E8%AF%BE%E7%A8%8B";
        window.open(url);
    }
    return (
        <div className="hkmaths">
            <div className="topBut">
                <button className="but2" onClick={() => { goMath('/hongkong/') }} >香港中文</button>
                <button className="but1" onClick={() => { goMath('/hongkongmaths/') }}>香港数学</button>
                <button className="but2" onClick={() => { goMath('/hongkong-English/') }} >香港英文</button>
            </div>
            <div className="mathsDiv">
                <div className="mathsHeader" onClick={() => { goUrl() }}>
                    <img src='../assets/Maths/bagYd.png' alt="" />
                </div>
                <div className="mathsContent">
                    {/* <!-- 公司簡介 --> */}
                    <div className="aboutUs">
                        <div className="aboutTitle">公司簡介</div>
                        <div className="aboutUs_content">
                            Sinobus中文由漢和文化科技有限公司創辦,總部位於中國·深圳,在中國·香港、中國·中山、中國·西安、美國·洛杉磯設有分公司。公司專注于為4-16歲海外華裔和K2-P6的港澳台地區學童提供系統、正規、科學的數學培訓服務。           </div>
                    </div>
                    <div className="aboutImg"><img src="../assets/maths/aboutus.png" alt="" /></div>
                    <div className="teacherModule">
                        <div className="teacherTitle">
                            <span className="big">名師介紹</span><span className="smile">-普教老師</span>
                            <div className="yellow_line"></div>
                        </div>
                        <div className="teacherContent">
                            {hkTeacher?.map((item, index) => {
                                return teacherInfoCom(item, index)
                            })} </div>
                        <div className="aboutImg" style={{ right: "-80%" }}> <img src="../assets/maths/apple.png" alt="" /></div>
                    </div>
                    <div className="teacherModule">
                        <div className="teacherTitle">
                            <span className="big">名師介紹</span><span className="smile">-粵教老師</span>
                            <div className="yellow_line"></div>
                        </div>
                        <div className="teacherContent1">
                            {hkTeacher.map((item, index) => {
                                if (index == 1) {
                                    return <div className="teacherContent1_item" style={{ backgroundColor: "#FFD465" }} key={index}>
                                        <div className="right">
                                            <div className="rightTitle">寧鈞龍老師</div>
                                            <div className="rightText">
                                                畢業於中國海洋大學，從事教育行業十年，擁有多年帶高考提分經驗，善於引起學生興趣，深入淺出，所帶學生考取華南農業大學、廣東工業大學等知名學府，深受家長和學生信賴，纍計多帶中小學生3000+。
                                            </div>
                                        </div>
                                        <div className="left left2">
                                            <img src="../assets/Maths/yt2.png" alt="" />
                                        </div>

                                    </div>
                                } else {
                                    return (<div className="teacherContent1_item" key={index}>
                                        <div className="left">
                                            <img src={item.picture2} alt="" />
                                        </div>
                                        <div className="right">
                                            <div className="rightTitle">{item.name}</div>
                                            <div className="rightText">
                                                {item.introduce}
                                            </div>
                                        </div>
                                    </div>)
                                }
                            })}
                        </div>
                        <EadlineCom name="博客" />
                        {
                            blogList != null ? <BlogCom data='1' blogLists={blogList} /> : null
                        }
                        <div className="courseInfo">
                            <div className="courseInfoTitle" >課程介紹</div>
                            <div className="courseContent">
                                <div >
                                    <div className="courseTitle"> 1.《現代小學數學》課程體系</div>
                                    <div className="grade">
                                        <img src='../assets/maths/gradeTable.png' alt="" />
                                    </div>
                                </div>
                                <div >
                                    <div className="courseTitle">2.課程研發</div>
                                    <div className="classResearch">課程設計基於香港小學《現代小學數學》內容、大綱文件《數學教育學習領域課程指導補充文件—小學數學科學學習內容》的指導方向，整合《數學課程進階訓練》《學生常犯錯500題》《應用題及解題思路》《26周學好數學》等相關配套練習編撰而成，全方位提升學生處理數、代數、度量、圖形與空間、數據處理問題的數學能力。</div>
                                    <div className="classList">
                                        {courseData.map((item, index) => { return classListCom(item, index) })}
                                    </div>
                                </div>
                                <div> <div className="courseTitle">
                                    3.課程特色
                                    <div className="classBag">
                                        <img src='../assets/maths/classMob.png' alt="" />
                                    </div>
                                </div>
                                </div>
                                <div >
                                    <div className="courseTitle" >
                                        4.1V多優勢
                                    </div>
                                    <div className="advantage">
                                        {
                                            courseHkList.map((item, index) => {
                                                return advantagetCom(item, index)
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mathsPc" >
                <div className="banner" onClick={() => { goUrl() }}>
                    <img src='../assets/Maths/banner.png' alt="" />
                </div>
                <div className="companyProfile">
                    <div className="titleBox">
                        <img className="icon_left" src="../assets/Maths/Ellipse13.png" alt="" />
                        <div className="title"><span className="bule">公司</span>簡介</div>
                        <img className="icon_right" src="../assets/Maths/Ellipse14.png" alt="" />
                    </div>
                    <div className="underline"></div>
                    <div className="content">Sinobus中文由漢和文化科技有限公司創辦,總部位於中國·深圳,在中國·香港、中國·中山、中國·西安、美國·洛杉磯設有分公司。公司專注于為4-16歲海外華裔和K2-P6的港澳台地區學童提供系統、正規、科學的數學培訓服務。</div>
                </div>
                {/* <!-- 老师介绍 --> */}
                <div className="teacher_introduced">
                    <div className="teacher_title">名師介紹</div>
                    <div className="nav">
                        <div className={["teacherNav1", 'teacherNav', isShow ? '' : 'yellow'].join(" ")} onClick={() => { setIsShow(false) }}>普教老師
                            {isShow ? "" : <img src="../assets/Maths/subtract1.png" alt="" />}
                        </div>
                        <div className={["teacherNav2", 'teacherNav', isShow ? 'yellow' : ''].join(" ")} onClick={() => { setIsShow(true) }}>粵教老師
                            {isShow ? <img src="../assets/Maths/subtract1.png" alt="" /> : ""}</div>
                    </div>
                    <div className="teacher_box">
                        {
                            isShow === true ?
                                dataList1.map((item, index) => {
                                    return teacherItemCom(item, index);
                                })
                                : hkTeacher.map((item, index) => {
                                    return teacherItemCom(item, index);
                                })
                        }
                    </div>
                </div>
                <EadlineCom name="博客" />
                {
                    blogList != null ? <BlogCom data='1' blogLists={blogList} /> : null
                }
                {/* <!-- 公司介绍 --> */}
                <div className="company_info">
                    <div className="titleBox">
                        <img className="icon_left" src="../assets/Maths/Ellipse13.png" alt="" />
                        <div className="title"><span className="bule">課程</span>簡介</div>
                        <img className="icon_right" src="../assets/Maths/Ellipse14.png" alt="" />
                    </div>
                    <div className="underline"></div>
                    <div >
                        <div className="subheading">1.《現代小學數學》課程體系</div>
                        <div className="tableImg">
                            <img src='../assets/maths/table.png' alt="" />
                        </div>
                    </div>
                    <div >
                        <div className="subheading">2.課程研發</div>
                        <div className="subheadingContent">課程設計基於香港小學《現代小學數學》內容、大綱文件《數學教育學習領域課程指導補充文件—小學數學科學學習內容》的指導方向，整合《數學課程進階訓練》《學生常犯錯500題》《應用題及解題思路》《26周學好數學》等相關配套練習編撰而成，全方位提升學生處理數、代數、度量、圖形與空間、數據處理問題的數學能力。</div>
                        <div className="grade">
                            {
                                courseData?.map((item, index) => {
                                    return subheadingCom(item, index);
                                })
                            }
                        </div>
                    </div>
                    <div className="subheading" style={{ textAlign: " left" }}>3.課程特色</div>
                </div>
                <div className="cloudLeft" >
                    <div className="cloudLefImg">
                        <img src="../assets/Maths/Business1.png" alt="" />
                    </div>
                    <div className="round">
                        <img src='../assets/Maths/classpc.png' alt="" />
                    </div>
                </div>
                <div> <div className="subheading">4.1V多優勢</div>
                    <div className="cloudRight">
                        <div className="cloudRightBox">
                            <div className="cloudRight_img">
                                <img src="../assets/Maths/Business2.png" alt="" />
                            </div>
                            <ul>
                                {
                                    courseHkList.map((item, index) => {
                                        return (<li key={index}>
                                            <img src="../assets/Maths/selected.png" alt="" />
                                            <div>{item.content}</div>
                                        </li>)
                                    })
                                }
                            </ul>
                        </div>
                    </div></div>

            </div>
            <ChatCom />
        </div>
    )
}
export default HongKongMathsPage;